export const AMBASSADOR_REVIEW_STATUSES = [
  { label: "Pending Review", value: "review" },
  { label: "Accepted", value: "accepted" },
  { label: "Rejected", value: "rejected" },
];
